<template>
  <div class="is-fluid">
    <section class="box">
      <section class="p-md">
        <div class="tile is-ancestor">
          <div class="tile is-1 is-vertical is-parent" />
          <div class="tile is-parent">
            <div class="tile is-child box">
              <p class="title has-text-weight-light">
                {{ $t('candidate.profile.profile_info') }}
              </p>
              <hr>
              <div v-if="!editAccount">
                <div class="columns is-size-5">
                  <div class="column ">
                    <div>
                      <span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.last_name') }}:</span>
                    </div>
                    <div class="p-l-lg">
                      {{ account.last_name }}
                    </div>
                  </div>
                  <div class="column">
                    <div><span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.first_name') }}:</span></div>
                    <div class="p-l-lg">
                      {{ account.first_name }}
                    </div>
                  </div>
                </div>
                <div class="columns is-size-5">
                  <div class="column ">
                    <div><span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.email') }}:</span></div>
                    <div class="p-l-lg">
                      {{ account.email }}
                    </div>
                  </div>
                  <div class="column">
                    <div><span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.phone') }}:</span></div>
                    <div class="p-l-lg">
                      {{ account.phone }}
                    </div>
                  </div>
                </div>
                <div class="columns is-size-5">
                  <div class="column ">
                    <div><span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.address') }}:</span></div>
                    <div class="p-l-lg">
                      {{ account.address }}
                    </div>
                  </div>
                  <div class="column">
                    <div><span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.address_complement') }}:</span></div>
                    <div class="p-l-lg">
                      {{ account.address_complement }}
                    </div>
                  </div>
                </div>
                <div class="columns is-size-5">
                  <div class="column ">
                    <div><span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.post_code') }}:</span></div>
                    <div class="p-l-lg">
                      {{ account.post_code }}
                    </div>
                  </div>
                  <div class="column">
                    <div><span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.city') }}:</span></div>
                    <div class="p-l-lg">
                      {{ account.city }}
                    </div>
                  </div>
                </div>
                <div class="columns is-size-5">
                  <div class="column ">
                    <div><span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.country') }}:</span></div>
                    <div class="p-l-lg">
                      {{ accountCountry ? accountCountry.country:null }}
                    </div>
                  </div>
                  <div class="column" />
                </div>

                <div class="has-text-right">
                  <button
                    class="button"
                    @click="editProfile()"
                  >
                    {{ $t('candidate.profile.edit_profile') }}
                  </button>
                </div>
              </div>

              <div v-else>
                <form @submit.prevent="updateProfile">
                  <div class="columns is-size-5">
                    <div class="column">
                      <div>
                        <span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.last_name') }}:</span>
                      </div>
                      <label>
                        <input
                          v-model="account.last_name"
                          class="input"
                          type="text"
                          name="last_name"
                        >
                      </label>
                    </div>
                    <div class="column">
                      <div>
                        <span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.first_name') }}:</span>
                      </div>
                      <label>
                        <input
                          v-model="account.first_name"
                          class="input"
                          type="text"
                          name="first_name"
                        >
                      </label>
                    </div>
                  </div>
                  <div class="columns is-size-5">
                    <div class="column ">
                      <div><span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.email') }}:</span></div>
                      <label>
                        <input
                          v-model="account.email"
                          class="input"
                          type="text"
                          name="email"
                        >
                      </label>
                    </div>
                    <div class="column">
                      <div><span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.phone') }}:</span></div>
                      <label>
                        <input
                          v-model="account.phone"
                          class="input"
                          type="text"
                          name="phone"
                        >
                      </label>
                    </div>
                  </div>
                  <div class="columns is-size-5">
                    <div class="column ">
                      <div><span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.address') }}:</span></div>
                      <label>
                        <input
                          v-model="account.address"
                          class="input"
                          type="text"
                          name="address"
                        >
                      </label>
                    </div>
                    <div class="column">
                      <div><span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.address_complement') }}:</span></div>
                      <label>
                        <input
                          v-model="account.address_complement"
                          class="input"
                          type="text"
                          name="address_complement"
                        >
                      </label>
                    </div>
                  </div>
                  <div class="columns is-size-5">
                    <div class="column ">
                      <div><span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.post_code') }}:</span></div>
                      <label>
                        <input
                          v-model="account.post_code"
                          class="input"
                          type="text"
                          name="post_code"
                        >
                      </label>
                    </div>
                    <div class="column">
                      <div><span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.city') }}:</span></div>
                      <label>
                        <input
                          v-model="account.city"
                          class="input"
                          type="text"
                          name="city"
                        >
                      </label>
                    </div>
                  </div>
                  <div class="columns is-size-5">
                    <div class="column ">
                      <div><span class="has-text-weight-bold is-italic">{{ $t('candidate.contact.country') }}:</span></div>
                      <label>
                        <b-select
                          v-model="account.country"
                          name="country"
                        >
                          <option value="">---</option>
                          <option
                            v-for="country in countries"
                            :value="country['alpha-2']"
                          >
                            {{ country.country }}
                          </option>
                        </b-select>
                      </label>
                    </div>
                    <div class="column" />
                  </div>
                  <p class="title has-text-weight-light">
                    {{ $t('candidate.profile.edit_password') }}
                  </p>
                  <hr>
                  <div class="columns is-size-5">
                    <div class="field is-horizontal">
                      <div class="field-body">
                        <div class="column ">
                          <div class="field">
                            <p class="control is-expanded has-icons-left has-icons-right">
                              <b-field
                                :label="$t('connection.password')"
                                class="has-text-left"
                              >
                                <b-input
                                  ref="password"
                                  v-model="account.password"
                                  v-validate="'required'"
                                  type="password"
                                  name="password"
                                  icon="lock"
                                  minlength="6"
                                  password-reveal
                                  :data-vv-as="$t('connection.password')"
                                />
                              </b-field>
                            </p>
                          </div>
                        </div>
                        <div class="column ">
                          <div class="field">
                            <p class="control is-expanded has-icons-left has-icons-right">
                              <b-field
                                :label="$t('connection.password_confirmation')"
                                class="has-text-left"
                              >
                                <b-input
                                  v-model="account.password_confirmation"
                                  v-validate="'required|confirmed:password'"
                                  type="password"
                                  name="password_confirmation"
                                  icon="lock"
                                  minlength="6"
                                  password-reveal
                                  :data-vv-as="$t('connection.password_confirmation')"
                                />
                              </b-field>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="has-text-right">
                    <button :class="'button-valid button ' + isLoading">
                      {{ $t('labels.general.save') }}
                    </button>
                    <br>
                    <br>
                    <transition name="slide-fade">
                      <div class="has-text-danger has-text-centered">
                        {{ errorMsg }}
                      </div>
                    </transition>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="tile is-1 is-vertical is-parent" />
        </div>

        <div class="tile is-ancestor">
          <div class="tile is-1 is-vertical is-parent" />
          <div class="tile is-parent">
            <div class="tile is-child box">
              <p class="title has-text-weight-light">
                {{ $t('candidate.profile.documents') }}
              </p>
              <hr>
              <div
                v-if="scholarDocuments.length"
                class="m-t-md"
              >
                <div class="is-size-5 has-text-weight-light">
                  {{ $t('candidate.profile.scholar') }}
                </div>

                <div v-for="document in scholarDocuments">
                  <a
                    v-if="document.path"
                    :href="'/api/document_shared/'+document.path+'?token='+ token"
                    target="_blank"
                  >{{ document.name }}</a>
                </div>
              </div>

              <div
                v-if="traineeDocuments.length"
                class="m-t-md"
              >
                <div class="is-size-5 has-text-weight-light">
                  {{ $t('candidate.profile.internship') }}
                </div>

                <div v-for="document in traineeDocuments">
                  <a
                    v-if="document.path"
                    :href="'/api/document_shared/'+document.path+'?token='+ token"
                    target="_blank"
                  >{{ document.name }}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="tile is-1 is-vertical is-parent" />
        </div>

        <div class="tile is-ancestor">
          <div class="tile is-1 is-vertical is-parent" />
          <div class="tile is-parent">
            <div class="tile is-child box">
              <p
                id="payments"
                class="title has-text-weight-light"
              >
                {{ $t('candidate.profile.order_log') }}
              </p>

              <b-collapse
                v-for="(order,index) in completeOrders"
                :key="order.id"
                class="card m-lg"
                :open="index === 0"
              >
                <div
                  slot="trigger"
                  slot-scope="props"
                  class="card-header"
                >
                  <p class="card-header-title is-size-4 has-text-weight-light">
                    <i>Commande N° {{ order.id }} confirmée le {{ order.payment_date | moment }}</i>
                  </p>
                  <a class="card-header-icon">
                    <b-icon
                      type="is-primary"
                      size="is-large"
                      :icon="props.open ? 'chevron-down' : 'chevron-up'"
                    />
                  </a>
                </div>
                <div class="card-content">
                  <div class="content">
                    <component
                      :is="completeView"
                      :order="order"
                      :candidates="activeCandidates"
                      :status="'complete'"
                    />
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
          <div class="tile is-1 is-vertical is-parent" />
        </div>
      </section>
    </section>
  </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import CompleteView from '../../../offers/components/order/Complete'
    import CountriesEN from '../../../utils/countries_en.json'
    import CountriesFR from '../../../utils/countries_fr.json'
    export default {

        data () {
            return {
                isLoading: '',
                errorMsg: '',
                completeView: CompleteView,
                countries: null,
                editAccount: false
            }
        },
        computed: {
            ...mapGetters(
                'candidate', [
                    'activeCandidates',
                    'hasCandidates',
                    'hasSchoolingCandidates'
                ]
            ),
            ...mapGetters({
                status: 'auth/getStatus',
                token: 'auth/getToken',
                account: 'auth/getAccount',
                isLoggedIn: 'auth/isLoggedIn'
            }),
            ...mapGetters(
                'orders', [
                    'completeOrders',
                    'isSchoolingOrder'
                ]
            ),
            accountCountry() {
                return this.countries.filter(country => country['alpha-2'] === this.account.country)[0]
            },
            traineeDocuments() {
                let documents = []
                if (this.activeCandidates) {
                    this.activeCandidates.map(function (candidate) {
                        if (candidate.documents && candidate.documents.trainee) {
                            candidate.documents.trainee.map(function (d) {
                                if (!documents.some(doc => doc.id === d.id)) {
                                    documents.push(d)
                                }
                            })
                        }

                    })
                }

                return documents
            },
            scholarDocuments() {
                let documents = []
                if (this.activeCandidates) {
                    this.activeCandidates.map(function (candidate) {
                        if (candidate.documents && candidate.documents.scolarity) {
                            candidate.documents.scolarity.map(function (d) {
                                if (!documents.some(doc => doc.id === d.id)) {
                                    documents.push(d)
                                }
                            })
                        }

                    })
                }

                return documents
            }
        },
        methods: {
            ...mapActions('auth', [
                'setAccount',
                'updateAccount',
                'logout'
            ]),
            ...mapActions(
                'orders', [
                    'setUserCompleteOrders'
                ]
            ),
            toggleLoading: function () {
                this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
            },
            editProfile() {
                this.editAccount = true
            },
            updateProfile() {
                this.$validator.validateAll().then((valid) => {
                    this.toggleLoading()
                    if ((!this.account.password) || valid) {
                        this.updateAccount(this.account).then((result) => {
                            if (this.status === 200) {
                                this.toggleLoading()
                                this.editAccount = false
                            } else if (this.status === 403) {
                                this.toggleLoading()
                                this.notAuthenticated()
                            } else {
                                this.toggleLoading()
                                this.errorMsg = this.$t('candidate.general.unknown')
                            }
                        }).catch(() => {
                            this.toggleLoading()
                            this.errorMsg = this.$t('candidate.general.unknown')
                        })
                    } else {
                        this.toggleLoading()
                        this.errorMsg = this.$t('candidate.contact.validation.empty_field')
                    }
                })
            },
            notAuthenticated () {
                this.$router.replace({ 'path': '/admissioneschool/' + this.school.slug + '/connexion' })
                this.logout()
            },
        },
        filters: {
            moment: function (date) {
                return moment(date, 'DD/MM/YYYY hh:mm').format('LL')
            }
        },
        created () {
            this.setAccount()
            this.setUserCompleteOrders(this.account.id)
            this.countries = CountriesFR

            if (this.$route.hash === '#payment') {
                setTimeout(() => {
                    this.$scrollTo('#payments', 500, { offset: -50 })
                }, 50)
            }
        }
    }
</script>
